// Helper function to parse and compare quote numbers
function compareQuoteNumbers(a, b) {
  if (!a || !b) return 0;

  const parseQuoteNumber = (quoteNum) => {
    const parts = quoteNum.toString().split('-');
    return {
      year: parseInt(parts[0]) || 0,
      num: parseInt(parts[1]) || 0
    };
  };

  const aQuote = parseQuoteNumber(a);
  const bQuote = parseQuoteNumber(b);

  // First compare by year
  if (aQuote.year !== bQuote.year) {
    return aQuote.year - bQuote.year;
  }

  // Then compare by number
  return aQuote.num - bQuote.num;
}

export function descendingComparator(a, b, orderBy) {  
  
  if (orderBy === 'quoteNumber') {
    return compareQuoteNumbers(b[orderBy], a[orderBy]);
  }

  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

export function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}